import {
  BBadge,
  BBreadcrumb,
  BBreadcrumbItem,
  BButton,
  BButtonClose,
  BButtonGroup,
  BCard,
  BCol,
  BContainer,
  BDropdown,
  BDropdownDivider,
  BDropdownGroup,
  BDropdownItem,
  BDropdownText,
  BEmbed,
  BForm,
  BFormCheckbox,
  BFormCheckboxGroup,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormRadio,
  BFormRadioGroup,
  BFormSelect,
  BFormText,
  BFormTextarea,
  BIcon,
  BIconArrowLeft,
  BIconCaretDownFill,
  BIconChatLeft,
  BIconChevronDown,
  BIconChevronLeft,
  BIconChevronUp,
  BIconCircle,
  BIconDashCircleFill,
  BIconDownload,
  BIconFolder,
  BIconInfoCircle,
  BIconPaperclip,
  BIconPersonCircle,
  BIconPlus,
  BIconSearch,
  BIconSlashCircle,
  BIconStar,
  BIconStarFill,
  BIconstack,
  BIconThreeDots,
  BIconX,
  BIconXCircleFill,
  BImg,
  BInputGroup,
  BInputGroupAppend,
  BInputGroupPrepend,
  BListGroup,
  BListGroupItem,
  BModal,
  BNav,
  BNavbar,
  BNavbarNav,
  BNavForm,
  BNavItem,
  BNavItemDropdown,
  BNavText,
  BOverlay,
  BPagination,
  BPopover,
  BRow,
  BSpinner,
  BTable,
  BTableSimple,
  BTbody,
  BTd,
  BTh,
  BThead,
  BToast,
  BTooltip,
  BTr,
  ModalPlugin,
  ToastPlugin,
  VBModal,
  VBPopover,
} from "bootstrap-vue";
import { createPinia, PiniaVuePlugin, setActivePinia } from "pinia";
import piniaPersist from "pinia-plugin-persistedstate";
import Vue from "vue";
import InfiniteLoading from "vue-infinite-loading";
import VueObserveVisibility from "vue-observe-visibility";
import App from "./App.vue";
import { AllowFeaturePlugin } from "./direct-app-config";
import router from "./router";
import sanitizeHTML from "./sanitize";
import { ls } from "./store";
import { migrateLegacyPersistedState } from "./store/migrate-legacy";

import "./assets/custom.scss";

// jaリソースのみを取り込む
import moment from "moment";
import "moment/locale/ja";

import VueScrollTo from "vue-scrollto";
import sentry from "./sentry";

// ロケールの適用を import の副作用に任せず明示的に設定する。
// moment.locale() はロケールデータが未登録でも例外を投げず en へフォールバックするため、
// 適用できたかを確認して警告する（バンドル最適化で ja が落ちた場合の検知用）。
if (moment.locale("ja") !== "ja") {
  console.warn(
    "moment の ja ロケールを適用できませんでした。曜日・月名等が英語表記になります。",
  );
}

// Optionally install the BootstrapVue icon components plugin
// Vue.use(IconsPlugin)
Vue.component("BIcon", BIcon);
Vue.component("BIconstack", BIconstack);
Vue.component("BIconArrowLeft", BIconArrowLeft);
Vue.component("BIconCaretDownFill", BIconCaretDownFill);
Vue.component("BIconChatLeft", BIconChatLeft);
Vue.component("BIconChevronLeft", BIconChevronLeft);
Vue.component("BIconChevronDown", BIconChevronDown);
Vue.component("BIconChevronUp", BIconChevronUp);
Vue.component("BIconCircle", BIconCircle);
Vue.component("BIconDashCircleFill", BIconDashCircleFill);
Vue.component("BIconDownload", BIconDownload);
Vue.component("BIconInfoCircle", BIconInfoCircle);
Vue.component("BIconPaperclip", BIconPaperclip);
Vue.component("BIconPlus", BIconPlus);
Vue.component("BIconSearch", BIconSearch);
Vue.component("BIconStar", BIconStar);
Vue.component("BIconStarFill", BIconStarFill);
Vue.component("BIconThreeDots", BIconThreeDots);
Vue.component("BIconX", BIconX);
Vue.component("BIconXCircleFill", BIconXCircleFill);
Vue.component("BIconFolder", BIconFolder);
Vue.component("BIconPersonCircle", BIconPersonCircle);
Vue.component("BIconSlashCircle", BIconSlashCircle);

// component
Vue.component("b-badge", BBadge);
Vue.component("b-breadcrumb", BBreadcrumb);
Vue.component("b-breadcrumb-item", BBreadcrumbItem);
Vue.component("b-button", BButton);
Vue.component("b-button-close", BButtonClose);
Vue.component("b-button-group", BButtonGroup);
Vue.component("b-card", BCard);
Vue.component("b-dropdown", BDropdown);
Vue.component("b-dropdown-divider", BDropdownDivider);
Vue.component("b-dropdown-group", BDropdownGroup);
Vue.component("b-dropdown-item", BDropdownItem);
Vue.component("b-dropdown-text", BDropdownText);
Vue.component("b-embed", BEmbed);
Vue.component("b-form", BForm);
Vue.component("b-form-checkbox", BFormCheckbox);
Vue.component("b-form-checkbox-group", BFormCheckboxGroup);
Vue.component("b-form-file", BFormFile);
Vue.component("b-form-group", BFormGroup);
Vue.component("b-form-input", BFormInput);
Vue.component("b-form-radio-group", BFormRadioGroup);
Vue.component("b-form-select", BFormSelect);
Vue.component("b-form-text", BFormText);
Vue.component("b-form-textarea", BFormTextarea);
Vue.component("b-form-radio", BFormRadio);
Vue.component("b-img", BImg);
Vue.component("b-input-group", BInputGroup);
Vue.component("b-input-group-append", BInputGroupAppend);
Vue.component("b-input-group-prepend", BInputGroupPrepend);
Vue.component("b-list-group", BListGroup);
Vue.component("b-list-group-item", BListGroupItem);
Vue.component("b-modal", BModal);
Vue.component("b-nav", BNav);
Vue.component("b-nav-form", BNavForm);
Vue.component("b-nav-text", BNavText);
Vue.component("b-navbar", BNavbar);
Vue.component("b-navbar-nav", BNavbarNav);
Vue.component("b-nav-item", BNavItem);
Vue.component("b-nav-item-dropdown", BNavItemDropdown);
Vue.component("b-overlay", BOverlay);
Vue.component("b-pagination", BPagination);
Vue.component("b-popover", BPopover);
Vue.component("b-spiner", BSpinner);
Vue.component("b-table", BTable);
Vue.component("b-table-simple", BTableSimple);
Vue.component("b-tbody", BTbody);
Vue.component("b-td", BTd);
Vue.component("b-th", BTh);
Vue.component("b-thead", BThead);
Vue.component("b-tr", BTr);
Vue.component("b-toast", BToast);
Vue.component("b-tooltip", BTooltip);

// gridlayout
Vue.component("b-container", BContainer);
Vue.component("b-col", BCol);
Vue.component("b-row", BRow);

// directive
Vue.directive("b-modal", VBModal);
Vue.directive("b-popover", VBPopover);

Vue.use(ModalPlugin);
Vue.use(ToastPlugin);

// for LazyLoad
Vue.use(VueObserveVisibility);

Vue.use(VueScrollTo);

// for α／βの機能利用チェック
Vue.use(AllowFeaturePlugin);

// for vue-infinite-loading
Vue.use(InfiniteLoading);

// Pinia（Vue 2.7 では Vue.use(PiniaVuePlugin) が必要）
Vue.use(PiniaVuePlugin);
const pinia = createPinia();
pinia.use(piniaPersist);
// setup 外で useStore を使えるようにする（移行シム用）
setActivePinia(pinia);
// 旧 vuex-persistedstate('vuex') の永続値を Pinia へ一度だけ詰め替える（要注意4・案A）
migrateLegacyPersistedState(ls);

Vue.config.productionTip = false;
Vue.prototype.$sanitize = sanitizeHTML;

sentry.init(router);

// version-*.json ファイルURLを取得する
const versionJsonUrl = () => {
  const base = (window as unknown as Record<string, string>).__VERSION_FILE__;
  const urlObj = new URL(base, window.location.href);
  urlObj.searchParams.set("dtm", Date.now().toString());
  const versionJsonUrlWithCacheBuster = urlObj.toString();
  return versionJsonUrlWithCacheBuster;
};

// 生成されたバージョン情報を取得
// 取得できる → 最新環境
// 取得できない → 古い環境
const urlForFetch = versionJsonUrl();
fetch(urlForFetch)
  .then((response) => response.json())
  .then((data) => console.log("Version:", data.version))
  .catch((err) => {
    // 無限リロードを防ぐためにリロードは1回までしか行わない
    // リロード回数はsessionStorageに保存
    const reloadCount = Number(sessionStorage.getItem("reloadCount")) || 0;
    if (reloadCount < 1) {
      sessionStorage.setItem("reloadCount", String(reloadCount + 1));
      window.location.reload();
    } else {
      sentry.sendSentryError({
        type: "VersionCheckError",
        message: `Version check failed: ${urlForFetch}, Reload count: ${reloadCount}`,
        error: JSON.stringify(err),
      });
    }
  });

new Vue({
  router,
  pinia,
  render: (h) => h(App),
}).$mount("#app");
